import { render, staticRenderFns } from "./CrudGoals.vue?vue&type=template&id=5f7fe136&"
import script from "./CrudGoals.vue?vue&type=script&lang=js&"
export * from "./CrudGoals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports